import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// Pages
import Home from "./pages/Home";
import Join from "./pages/Join";
import Gallery from "./pages/Gallery";
import Events from "./pages/Events";
import OurStory from "./pages/OurStory";
import FAQ from "./pages/FAQ";
import Documents from "./pages/Documents";
import Resources from "./pages/Resources";
import NoPage from "./pages/NoPage";
// Components
import ScrollToTop from "./components/ScrollToTop"
// Font for arrows in the Gallery page
import '@fortawesome/fontawesome-free/css/all.min.css';

export default function App() {
	return (
			<BrowserRouter>
				{/*ScrollToTop makes sure the page scrolls to the top on navigation*/}
				<ScrollToTop />
				<Routes>
					<Route index element={<Home />} />
					<Route path="join" element={<Join />} />
					<Route path="gallery" element={<Gallery />} />
					{/*The events route is commented out when not being used make sure to uncomment the event lines in Landing.js and Header.js*/}
					{/*<Route path="events" element={<Events />} />*/}
					<Route path="our-story" element={<OurStory />} />
					<Route path="faq" element={<FAQ />} />
					<Route path="documents" element={<Documents />} />
					<Route path="resources" element={<Resources />} />
					<Route path="*" element={<NoPage />} />
				</Routes>
			</BrowserRouter>
	);
}

// Render React app to DOM
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);